


























import {Component, Mixins} from 'vue-property-decorator';
import {
  AdminPrivilegeResponse,
  CommonModelUtils,
  Session,
  SponsorSelectDialogRequest,
  SponsorSelectDialogResponse,
  UserSenderRetrieveResponse,
  UserSendersRetrieveResponse,
  UserSponsorRetrieveResponse,
} from '@/model/CommonModel';
import CommonPaginatedTable from '@/components/table/CommonPaginatedTable.vue';
import CommonPromptDialog from '@/components/dialog/CommonPromptDialog.vue';
import CommonButton from '@/components/button/CommonButton.vue';
import DialogEventsMixin from '../../components/dialog/DialogEventsMixin';
import SelectInput from '@/components/input/SelectInput.vue';
import CommonValidators from '@/validator/CommonValidators';
import UserApi from '@/api/UserApi';
import store from '@/store';
import DefaultComponentMixin from '@/views/DefaultComponentMixin';
import SystemAdminApi from '@/api/SystemAdminApi';
import AppSession from '@/store/AppSession';

@Component({
  components: {CommonPromptDialog, CommonPaginatedTable, CommonButton, SelectInput},
  mixins: [
    DialogEventsMixin, DefaultComponentMixin
  ]
})
export default class SponsorSelectDialog extends Mixins(DialogEventsMixin, DefaultComponentMixin) {
  private visible: boolean = false;
  private width: string = '568px';
  private sponsors: UserSponsorRetrieveResponse[] = [];
  private senders: UserSenderRetrieveResponse[] = [];

  private userKey: string = '';
  private onConfirm: (selected: SponsorSelectDialogResponse) => void;
  private onClose: any;
  private systemButtonVisible: boolean = false;
  private token: string = '';

  private form: any = {
    data: {
      selectedSponsorKey: '',
      selectedSenderKey: ''
    },
    rules: {
      selectedSponsorKey: [
        {validator: CommonValidators.sponsorRequired(this), trigger: 'change'},
        {validator: CommonValidators.required(this), trigger: 'submit'}
      ],
      selectedSenderKey: [
        {validator: CommonValidators.sponsorRequired(this), trigger: 'change'},
        {validator: CommonValidators.required(this), trigger: 'submit'},
      ]
    },
  };

  get hasUnSavedData() {
    const changed = Object.assign({}, store.state.valueChangedMap,
        store.state.notationChangedMap, store.state.nullFlavorChangedMap);
    return Object.keys(changed).length > 0;
  }

  get isVisible() {
    return this.visible;
  }

  get getSponsors() {
    return this.sponsors;
  }

  get getSenders() {
    return this.senders;
  }

  get isSystemButtonVisible() {
    return this.systemButtonVisible;
  }

  public mounted() {
    this.$modal
        .getEventBus()
        .$on('showSponsorSelectDialog', (request: SponsorSelectDialogRequest) => {
          this.show(request);
        });

    this.$modal.getEventBus().$on('hideSponsorSelectDialog', () => this.onCancel());
  }

  private show(request: SponsorSelectDialogRequest) {
    this.initData();
    const {
      userKey, selectedSponsorKey, selectedSenderKey,
      onConfirm, sponsors, onClose, width, token
    } = request;

    this.userKey = userKey;
    this.sponsors = sponsors;
    this.onConfirm = onConfirm;
    this.onClose = onClose;
    this.width = width ? width : this.width;

    if (token) {
      AppSession.setAccessToken(token);
      this.token = token;
    }

    const sponsorKey = selectedSponsorKey ?? (sponsors.length > 0 ? sponsors[0].sponsorKey : null);

    const getSendersApi = sponsorKey
        ? this.onSponsorInput(sponsorKey, selectedSenderKey).then(() => {
          this.form.data.selectedSponsorKey = this.isAdmin ? '' : +sponsorKey;
          this.form.data.selectedSenderKey = this.isAdmin ? '' : this.form.data.selectedSenderKey;
        })
        : Promise.resolve();

    getSendersApi
        .then(() => this.setSystemButtonVisible(userKey))
        .then(() => this.visible = true);
  }

  public setSystemButtonVisible(userKey: number | string) {
    return SystemAdminApi.getAdminPageAccessPrivilege(userKey)
        .then((res: AdminPrivilegeResponse) => {
          this.systemButtonVisible = res.data.isAdmin;
        })
        .catch((errMsg) => this.afterRequestFail(errMsg));
  }

  public onSponsorInput(sponsorKey: string | number, selectedSenderKey?: string | number) {
    this.form.data.selectedSenderKey = '';

    return UserApi.retrieveUserSenders(sponsorKey, this.userKey)
        .then((res: UserSendersRetrieveResponse) => {
          if (!res.success) {
            return Promise.reject(res.errMsg);
          }

          const senders = CommonModelUtils.getOrDefault(res.data, {senders: [{SENDER_KEY: ''}]}).senders;
          this.senders = senders;
          this.form.data.selectedSenderKey = selectedSenderKey ? +selectedSenderKey : senders[0].SENDER_KEY;

          if (!senders.find(
              (sender: UserSenderRetrieveResponse) => sender.SENDER_KEY === this.form.data.selectedSenderKey)) {
            this.form.data.selectedSenderKey = '';
          }
          return {senders};
        })
        .catch((errMsg) => this.afterRequestFail(errMsg));
  }

  public opened() {
    const element: any = this.$refs.okButton;
    element.focus();
  }

  public onOk() {
    const $refFrom: any = this.$refs.form;
    $refFrom.validate((valid: boolean, result: any) => {
      if (valid) {
        this.onSuccess();
      }
    });
  }

  public onSystem() {
    if (!this.$route.meta.isAdmin) {
      const session: Session = {
        userKey: parseInt(this.userKey, 10),
        userId: '',
        sponsorKey: 1,
        sessionSenderKey: -1,
        token: AppSession.getAccessToken() || this.token
      };

      this.$store.commit('setSession', session);
      this.$router.push({
        name: 'SystemAdmin',
        params: {
          language: 'en'
        }
      });
    }

    this.onCancel();
  }

  public onSuccess() {
    if (typeof this.onConfirm === 'function') {
      this.onConfirm({
        sponsorKey: this.form.data.selectedSponsorKey,
        sessionSenderKey: this.form.data.selectedSenderKey
      });
    }

    this.onCancel();
  }

  public onCancel() {
    this.visible = false;

    if (typeof this.onClose === 'function') {
      this.onClose();
    }
  }

  public initData() {
    this.form.data.selectedSponsorKey = '';
    this.form.data.selectedSenderKey = '';
    this.sponsors = [];
    this.senders = [];
  }

  public destroyed() {
    this.$modal.getEventBus().$off('showSponsorSelectDialog');
    this.$modal.getEventBus().$off('hideSponsorSelectDialog');
  }
}
